import { render } from "./AppModalHeader.vue?vue&type=template&id=7394ac0a&scoped=true&ts=true"
import script from "./AppModalHeader.vue?vue&type=script&lang=ts"
export * from "./AppModalHeader.vue?vue&type=script&lang=ts"

import "./AppModalHeader.vue?vue&type=style&index=0&id=7394ac0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7394ac0a"]])

export default __exports__